import {Link} from "react-router-dom";
import React from "react";
import KashimaIcon from "../assets/images/kashima.png";

export default function Footer() {
    return (
        <div className="main-footer">
            <div className="first-footer">
                <div className="footer-content">
                    <p className="footer-content-title">Pages</p>
                    <Link to="/" className="footer-content-page">Home</Link><br />
                    <Link to="/about" className="footer-content-page">FAQ</Link><br />
                    <Link to="/policy" className="footer-content-page">Privacy Policy</Link>
                </div>
                <div className="footer-name">
                    <img src={KashimaIcon} alt="kashima" />
                    <p>Kashima</p>
                </div>
            </div>
            <div className="another-footer-content">
                <p>Find me here</p>
                <div className="another-footer-content-parent">
                    {[{
                        name: "topgg",
                        embed: "https://discordbots.org/api/widget/424137718961012737.svg",
                        redirect: "https://discordbots.org/bot/424137718961012737"
                    }, {
                        name: "BFD",
                        embed: "https://botsfordiscord.com/api/bot/424137718961012737/widget?theme=dark",
                        redirect: "https://botsfordiscord.com/bots/424137718961012737"
                    }, {
                        name: "bots-on-discord",
                        embed: "https://bots.ondiscord.xyz/bots/424137718961012737/embed?theme=dark&showGuilds=true",
                        redirect: "https://bots.ondiscord.xyz/bots/424137718961012737"
                    }].map((x, i) => (<img alt={x.name} src={x.embed} onClick={() => window.location = x.redirect} key={i} />))}
                </div>
                <p>Our partner</p>
                <img className="partner" src="https://cdn.discordapp.com/attachments/551992888058183690/676006192723525642/Small_Banner_250x65.png" alt="erisly"/>
            </div>
            <div className="copyright">
                <p>©2021 The Shipgirl Project. All right reserved.</p>
            </div>
        </div>
    )
}